const contentTabs = document.querySelectorAll('[data-tab-button]');
const contentCards = document.querySelectorAll('[data-tab-card]');

const showCard = tabIndex => {
  contentCards.forEach(cc => {
    let cardIndex = cc.getAttribute('data-tab-card');
    if (cardIndex == tabIndex) {
      console.log('Card found, id:', cardIndex);
      cc.classList.remove('hide-card');
    } else {
      !cc.classList.contains('hide-card') ? cc.classList.add('hide-card') : '';
    }
  });
};

const highlightTab = tabIndex => {
  contentTabs.forEach(contentTab => {
    let ctIndex = contentTab.getAttribute('data-tab-button');

    if (tabIndex == ctIndex) {
      contentTab.classList.add('tab-button-active');
      console.log(`Tab match: ${tabIndex} | ${ctIndex}`);
    } else {
      contentTab.classList.remove('tab-button-active');
    }
  });
};

contentTabs.forEach(ct => {
  let tab = ct;
  if (!ct.classList.contains('tab-button')) tab = ct.closest('.tab-button');

  tab.addEventListener('click', e => {
    let tabIndex = tab.getAttribute('data-tab-button');

    // Set active tab button
    highlightTab(tabIndex);

    // Show proper card
    showCard(tabIndex);
  });
});
